import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { on } from '@ember/modifier';
import { assert } from '@ember/debug';

import {
  HdsButton,
  HdsButtonSet,
  HdsModal,
  HdsModalColorValues,
} from '@hashicorp/design-system-components/components';
import { HdsButtonColorValues } from '@hashicorp/design-system-components/components/hds/button/types';

import { optional } from '@nullvoxpopuli/ember-composable-helpers';

import type Owner from '@ember/owner';

export interface ManageAccessModalManageTerraformSignature {
  Args: {
    onClose?: () => void;
    onSubmit: () => void;
  };
  Blocks: {
    default?: [];
  };
  Element: HTMLElement;
}

export default class ManageAccessModalManageTerraformComponent extends Component<ManageAccessModalManageTerraformSignature> {
  constructor(
    owner: Owner,
    args: ManageAccessModalManageTerraformSignature['Args'],
  ) {
    super(owner, args);

    const { onClose, onSubmit } = this.args;

    assert(
      'ManageAccessModalManageTerraformComponent required argument @onSubmit is a defined function',
      typeof onSubmit === 'function',
    );

    if (onClose) {
      assert(
        'ManageAccessModalManageTerraformComponent required argument @onClose is a defined function but not required',
        typeof onClose === 'function',
      );
    }
  }

  handleOnSubmit = (e: Event) => {
    e.preventDefault();

    const { onSubmit } = this.args;

    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit();
    }
  };

  <template>
    <HdsModal
      @color={{HdsModalColorValues.Warning}}
      @onClose={{optional @onClose}}
      ...attributes
      data-test-modal-unsaved-changes-manage-terraform
      as |M|
    >
      <M.Header
        @icon="alert-triangle"
        data-test-modal-unsaved-changes-manage-terraform-header
      >
        {{t
          "manage-access.components.modal.unsaved-changes-manage-terraform.you-have-unsaved-changes"
        }}
      </M.Header>
      <M.Body data-test-modal-unsaved-changes-manage-terraform-body>
        <form
          id="unsaved-changes-manage-terraform"
          novalidate
          {{on "submit" this.handleOnSubmit}}
        >
          {{t
            "manage-access.components.modal.unsaved-changes-manage-terraform.you-have-unsaved-role-assignments"
          }}
        </form>
      </M.Body>
      <M.Footer data-test-modal-unsaved-changes-manage-terraform-footer as |F|>
        <HdsButtonSet>
          <HdsButton
            @color={{HdsButtonColorValues.Primary}}
            @text={{t
              "manage-access.components.modal.unsaved-changes-manage-terraform.save-and-continue"
            }}
            form="unsaved-changes-manage-terraform"
            type="submit"
            data-test-modal-button-submit
          />
          <HdsButton
            @color={{HdsButtonColorValues.Secondary}}
            @text={{t
              "manage-access.components.modal.unsaved-changes-manage-terraform.cancel"
            }}
            data-test-modal-button-cancel
            {{on "click" F.close}}
          />
        </HdsButtonSet>
      </M.Footer>
    </HdsModal>
  </template>
}
